<template>
  <div class="page">
    <Header
        :title=pageTitle
    />
    <div class="wiki-body">
      <main class="main">
        <div class="container-fluid">
          <div class="container dashboard page-content fadeIn index no-center">
            <div v-if="editing">
              <textarea v-model="editContent" class="edit-area form-control"></textarea>
              <div class="file-forms-container">
                <div class="file-forms" id="file-form">
                </div>
                <div class="file-form-add">
                  <button @click="addFileForm" class="btn btn-primary ml-1">Add file</button>
                </div>
              </div>
              <div class="flex flex-row-reverse">
                <button @click="saveContent" class="btn btn-primary ml-1">Save</button>
                <button @click="cancelEditing" class="btn btn-secondary ml-1">Cancel</button>
              </div>
            </div>
            <div v-else v-html="renderedContent"></div>
            <div class="flex flex-row-reverse" v-if="!editing && loaded">
              <button class="btn btn-primary ml-1" @click="startEditing">
                Edit
              </button>
              <button @click="toggleHistory" class="btn btn-secondary ml-1">Toggle History</button>
            </div>

            <div v-if="showHistory">
              <h3>History</h3>
              <ul>
                <li v-for="item in history" :key="item.Id">
                  <p><strong>Edited at:</strong> {{ item.CreatedAt }}</p>
                  <p><strong>Content:</strong></p>
                  <div v-html="renderedHistoryContent(item.Content)"></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {TokenMixin} from '@/assets/js/mixins/token-mixin';
import Header from './Header.vue';
import {marked} from 'marked';
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: 'Index',
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  components: {
    Header
  },
  data() {
    return {
      content: '<a href="/">loading...</a>',
      pageId: null,
      pageTitle: 'Wiki',
      title: 'Wiki',
      editPageUrl: '/api/page/',
      pageApiUrl: '/api/page/list?limit=1&sort=id',
      editing: false,
      editContent: '',
      error: '',
      showHistory: false,
      loaded: false,
      uploadApi: '/api/page/upload'
    };
  },
  computed: {
    renderedContent() {
      return marked(this.content);
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadHistory(pageId) {
      axios.get(`/api/page/${pageId}`, this.authRespConf())
          .then(res => {
            if (res.data && res.data.custom && res.data.custom.history) {
              this.history = res.data.custom.history;
            }
          })
          .catch(err => {
            this.errorHandle(err, true, true);
            console.log('Error loading history:', err);
          });
    },
    createWikiPage() {
      let loader = this.$loading.show();
      axios.post(this.editPageUrl, {"Title": "Wiki page", "Slug": "wiki", "Content": ""}, this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.errorHandle(err, true, true, 'Create a new wiki page error');
          })
          .then(() => {
            this.loadData(false)
          });
    },
    loadData(create = true) {
      let loader = this.$loading.show();
      axios.post(this.pageApiUrl, [{"Condition": "=", "Data": {"Slug": "wiki"}}], this.authRespConf())
          .catch((err) => {
            console.log(err);
            loader.hide();
            this.errorHandle(err, true, true);
            this.content = 'load data error';
          })
          .then(res => {
            loader.hide();
            if (!res.data) {
              return;
            }
            if (!res.data.data[0]) {
              if (create) {
                this.createWikiPage()
              }
              return;
            }
            this.content = res.data.data[0].Content;
            this.pageId = res.data.data[0].Id;
            this.loadHistory(this.pageId);
            this.loaded = true;
          });
    },
    startEditing() {
      this.editContent = this.content;
      this.editing = true;
    },
    cancelEditing() {
      this.editing = false;
    },
    toggleHistory() {
      this.showHistory = !this.showHistory;
    },
    renderedHistoryContent(content) {
      return marked(content);
    },
    saveContent() {
      let loader = this.$loading.show();
      axios.patch(this.editPageUrl, {"Content": this.editContent, Id: this.pageId}, this.authRespConf())
          .then(() => {
            this.content = this.editContent;
            this.editing = false;
          })
          .catch((err) => {
            loader.hide();
            this.errorHandle(err, true, true, 'Save content error');
          })
          .finally(() => {
            loader.hide();
          });
    },
    addFileForm() {
      let block = document.createElement("div");
      let postfix = Date.now();
      let inputId = "file-input-" + postfix;
      let btnId = "result-btn-" + postfix;
      let resultId = "result-upload-" + postfix;

      let input = document.createElement("input");
      input.type = "file";
      input.name = "file";
      input.setAttribute("id", inputId);

      let btn = document.createElement("input");
      btn.setAttribute("class", "btn btn-primary ml-1");
      btn.setAttribute("type", "submit");
      btn.setAttribute("value", "Upload");
      btn.setAttribute("id", btnId);

      let resultBlock = document.createElement("span");
      resultBlock.setAttribute("class", "xfa xfa-copy result-upload");
      resultBlock.setAttribute("id", resultId);

      btn.onclick = () =>  {}
      block.append(resultBlock);

      block.append(input);
      block.append(btn);
      btn.onclick = () =>  {
        const fileInput = document.getElementById(inputId);
        if (fileInput === null) {
          alert("Please select a file first");
          return;
        }
        const file = fileInput.files[0];

        if (!file) {
          alert("Please select a file first!");
          return;
        }

        const formData = new FormData();
        formData.append('file', file);

        let loader = this.$loading.show();
        axios.post(this.uploadApi, formData, this.authRespConf())
            .then((res) => {
              if (res !== null && res !== undefined) {
                document.getElementById(inputId).remove();
                document.getElementById(btnId).remove();
                resultBlock.textContent = "New file path: " + res.data.data;
                this.$bvToast.toast(res.data.data, {
                  title: 'Upload file successful',
                  autoHideDelay: 10000,
                  variant: 'info',
                  appendToast: true
                });
              }
            })
            .catch((err) => {
              loader.hide();
              this.errorHandle(err, true, true, 'Upload file error');
            })
            .finally(() => {
              loader.hide();
            });
      }
      document.getElementById("file-form").append(block);
    }
  }
}
</script>

<style scoped>
.center {
  vertical-align: middle;
  text-align: center;
}

.edit-area {
  width: 100%;
  height: 300px;
}

.container.dashboard {
  width: 100%;
  margin: 0 0 0 1.5rem;
}
.file-form-add, #file-form {
  margin: 10px 0 10px 0;
}
.file-forms-container {
  float: left;
}
</style>
